<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <div class="page_container mb-0 pb-0">
      <div class="main__title">
        <span class="main__title--text">
          Главная страница
        </span>
        <span v-if="getUserStatus.approve && !getUserStatus.agreement" class="btn_science_id" @click="scienceId_dialog = true">
          <span v-if="$vuetify.display.width > 768">стать участником </span>
          <span class=ml-1> science-id</span>
        </span>
      </div>
    </div>
    <UserInfo v-if="getUserStatus.approve && !getUserStatus.agreement"/>
    <UserPromocodes v-if="getUserStatus.approve && !getUserStatus.agreement"/>
    <PageNotValid class="pt-0" v-else-if="getUserStatus.is_not_valid"/>
    <PageWaitApprove class="pt-0" v-else-if="!getUserStatus.approve && getUserStatus.special && !getUserStatus.agreement"/>
    <PageNotAllowed class="pt-0" v-else/>
    <UserPartners/>

    <user-science-id-dialog
        v-model="scienceId_dialog"
        v-if="scienceId_dialog"
        @save="clickScienceId"
        @close="scienceId_dialog = false"
    />
  </v-container>
</template>

<script>
import UserInfo from "@/modules/personal_account/users/components/UserInfo.vue"
import UserPromocodes from "@/modules/personal_account/users/components/UserPromocodes.vue"
import UserPartners from "@/modules/personal_account/users/components/UserPartners.vue"
import { mapActions, mapGetters } from "vuex"
import PageNotAllowed from "@/modules/templates/PageNotAllowed.vue"
import names from "@/modules/core/routers/names"
import PageWaitApprove from "@/modules/templates/PageWaitApprove.vue"
import PageNotValid from "@/modules/templates/PageNotValid.vue"
import UserScienceIdDialog from "@/modules/personal_account/users/modals/UserScienceIdDialog.vue"

export default {
  name: 'UserPage',
  components: {
    UserScienceIdDialog,
    PageNotValid,
    PageWaitApprove,
    PageNotAllowed,
    UserPartners,
    UserPromocodes,
    UserInfo
  },
  data () {
    return {
      names () {
        return names
      },
      scienceId_dialog: false,
    }
  },
  computed: {
    ...mapGetters({
      getUserStatus: 'auth/getUserStatus',
    })
  },
  methods: {
    ...mapActions({
      redirectTo: 'personal_account/science_id/redirectTo'
    }),
    clickScienceId () {
      this.redirectTo(
        {
          finalizer: (data) => {
            window.location.href = data.redirect
          },
          catcher: () => {}
        }
      )
    }
  },
  created () {
    if (!this.getUserStatus) {
      this.$router.push({ name: names.MAIN })
    }
  }
}
</script>

<style scoped lang="scss">

.main__title {
  display: flex;
  justify-content: space-between;
}

.main__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.btn_science_id {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  padding: 0 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #3254B9;
  border: 1px solid #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: #3254B9;
    color: #FFFFFF;
  }

  &.click {
    background-color: #3254B9;
    color: #FFFFFF;
  }
}

@media screen and (max-width: 768px) {
  .btn_science_id {
    height: 17px;
    font-size: 12px;
    line-height: 14px;
  }

  .main__title {
    margin-top: 20px;
  }

  .main__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }
}
</style>
